(function(Manogi, $, undefined) {
    
    //Private

    
    
  
    //Public

    Manogi.closeFlash = function($flash) {
        $flash.slideUp(600);
    };

    Manogi.delayedCloseFlash = function($flash) {
        window.setTimeout(function(){
            Manogi.closeFlash($flash);
        }, 3000);
    };

    Manogi.openFlash = function($flash) {
        $flash.slideDown(600);
    };

    Manogi.delayedOpenFlash = function($flash) {
        window.setTimeout(function(){
            Manogi.openFlash($flash);
        }, 200);
    };

    Manogi.flash = function(message, cssStyle) {
        $('.flashes').prepend('<div class="js-flash flash--'+cssStyle+'">'+message+'</div>');
    };


}( window.Manogi = window.Manogi || {}, jQuery ));